import { trackAdobeWidgetImpression } from './adobe';
import { intercomEvent } from './intercom';

export function trackConnectionsLoaded() {
  trackAdobeWidgetImpression(['CONNECTIONS_WIDGET']);
  intercomEvent('connections');
}

export function trackConnectionsNotLoaded() {
  trackAdobeWidgetImpression(['NO_CONNECTIONS_WIDGET']);
}
